import React, { useState } from 'react';
import Navbar from '../components/Navbar';
import Breadcrumb from '../components/Breadcrumb';
import ContentSplitSections from '../components/ContentSplitSections';
import HeroSectionSecondary from '../components/HeroSectionSecondary';
// import premiumPlans from '../data/premiumPlanData.js'; 
// import Package from '../components/Package.js';
import CTASection from '../components/CTASection';
import '../styles/snow.css'; 

const premiumSections = [
  {
    title: 'Residential Landscaping',
    text: 'Comprehensive residential services from installation to ongoing care that bring your outdoor spaces to life.',
    image: '/images/landscape/landscapeFull.png',
    buttonText2: "View Service",
    buttonLink2: "/landscape"
  },
  {
    title: 'Property Management',
    text: 'Complete outdoor care for residential and commercial properties. One contract, one partner — for everything outside your building.',
    image: '/images/hardscape/harscapeCommunity.png',
    buttonText2: "View Service",
    buttonLink2: "/PropertyManagementPage"
  },
  {
    title: 'Snow & Ice Management',
    text: 'Reliable snow plowing, hand shoveling, ice management and removal, keeping your property clear and accessible all winter.',
    image: '/images/snow/snowRoof2.png',
    buttonText2: "View Service",
    buttonLink2: "/Snow"
  },
  {
    title: 'Holiday Lighting',
    text: 'Professional-grade, energy-efficient lighting installed with care and creativity — designed to make every season shine.',
    image: '/images/lights/holidayAngle.png',
    buttonText2: "View Service",
    buttonLink2: "/Light"
  },
  {
    title: 'Tree Services',
    text: 'Comprehensive tree services including our selection of care, pruning, removal, and health assessments to maintain strong, thriving landscapes.',
    image: '/images/tree/treeHeroImage3.jpg',
    buttonText2: "View Service",
    buttonLink2: "/Tree"
  },
  {
    title: 'Fire Pit Installations',
    text: 'Custom fire pits designed and built to complement your space and extend your outdoor season.',
    image: '/images/fire/fireHeroImage.png',
    buttonText2: "View Service",
    buttonLink2: "/Fire"
  },
  {
    title: 'Seasonal Floral Displays',
    text: 'Vibrant, rotating floral designs tailored to each season — bringing color and character to your landscape.',
    image: '/images/flower/flowerHeroImage.png',
    buttonText2: "View Service",
    buttonLink2: "/Flower"
  },
  {
    title: 'Water Features',
    text: 'Custom ponds, streams, and waterfalls that add tranquility and movement to your property.',
    image: '/images/water/pondHouse.png',
    buttonText2: "View Service",
    buttonLink2: "/WaterFeature"
  },
  {
    title: 'Custom Fencing',
    text: 'Durable, beautifully crafted fencing solutions that balance privacy and aesthetics.',
    image: '/images/fence/fenceHeroImage.png',
    buttonText2: "View Service",
    buttonLink2: "/Fencing"
  },
  {
    title: 'Backflow Prevention',
    text: 'Professional backflow installation and testing to keep your irrigation systems operating safely and efficiently.',
    image: '/images/premium/backflowPrem.jpeg',
    buttonText2: "View Service",
    buttonLink2: "/Maintenance"
  },
   {
    title: 'Hot Tub Installation',
    text: 'Seamless coordination, preparation, and installation to integrate hot tubs into your outdoor spaces safely and beautifully.',
    image: '/images/premium/SAGEHOTTUB.jpg',
    buttonText2: "View Service",
    buttonLink2: "/Maintenance"
  },
];

const Premium = () => {
  const [showMoreSpring, setShowMoreSpring] = useState(false);
    const [showMoreSummer, setShowMoreSummer] = useState(false);
    const [showMoreFall, setShowMoreFall] = useState(false);
    const [showMoreWinter, setShowMoreWinter] = useState(false);
  
  return (
    <div className="premium-page">
      <Navbar />
      <Breadcrumb />

      <div className="hero-with-lights" style={{ position: 'relative' }}>
        <HeroSectionSecondary className="hero-lights"
          title="Signature Services"
          subtitle="Comprehensive outdoor solutions from the team you can trust, all year long."
          button1Text="Request a Consultation"
          button1Link="mailto:info@allseasons.info"
          target="_blank"
          rel="noopener noreferrer"
          button2Text="View Gallery"
          button2Link="/gallery"
          image="/images/premiumHero.png"
        />
      </div>
 {/* Year-Round Services - 2x2 Grid */}
      <section className="seasonal-services-visual">
        <div className="seasonal-container">
          <div className="seasonal-header">
            <h2>Year-Round Service Programs</h2>
            <p>Customizable maintenance packages for residential and commercial properties — tailored for every season and every need.</p>
          </div>

          <div className="seasonal-compact-grid">
            <div className="season-card-compact spring">
              <div className="season-image">
                <img src="/images/flower/flowerPurpleRed1.jpg" alt="Spring services - flower planting" />
              </div>
              <div className="season-content">
                <h3>Spring Services</h3>
                <p className="season-months">March – May</p>
                <div className="services-preview">
                  <ul>
                    <li>Spring clean-up (branches, debris, winter damage)</li>
                    <li>Irrigation system activation and tuning</li>
                    <li>Soil aeration and fertilization</li>
                    <li>Bed cultivation and edge refresh</li>
                    <li>Lawn de-thatching (if applicable)</li>
                  </ul>
                </div>
                <button className="expand-services-btn" onClick={() => setShowMoreSpring(!showMoreSpring)}>
                  {showMoreSpring ? 'View Less' : 'View More'}
                </button>
                
                <div className={`services-detailed ${showMoreSpring ? 'expanded' : ''}`}>
                  <div className="service-category">
                    <h4>Additional Standard Services</h4>
                    <ul>
                      <li>Early weed and pest management</li>
                      <li>Seasonal flower installation</li>
                      <li>Inspection of drainage systems</li>
                    </ul>
                  </div>
                  <div className="service-category">
                    <h4>Optional Add-ons</h4>
                    <ul>
                      <li>Mulch replenishment</li>
                      <li>Pressure washing patios/walkways</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="season-card-compact summer">
              <div className="season-image">
                <img src="/images/flower/flowerSummer.JPG" alt="Summer maintenance services" />
              </div>
              <div className="season-content">
                <h3>Summer Services</h3>
                <p className="season-months">June – August</p>
                <div className="services-preview">
                  <ul>
                    <li>Weekly landscape maintenance (mowing, edging, pruning)</li>
                    <li>Turf and plant health monitoring</li>
                    <li>Ongoing irrigation audits and adjustments</li>
                    <li>Weed, pest, and disease control</li>
                    <li>Mid-season fertilization</li>
                  </ul>
                </div>
                <button className="expand-services-btn" onClick={() => setShowMoreSummer(!showMoreSummer)}>
                  {showMoreSummer ? 'View Less' : 'View More'}
                </button>
                
                <div className={`services-detailed ${showMoreSummer ? 'expanded' : ''}`}>
                  <div className="service-category">
                    <h4>Additional Standard Services</h4>
                    <ul>
                      <li>Flower and bed care</li>
                      <li>Tree and shrub maintenance</li>
                    </ul>
                  </div>
                  <div className="service-category">
                    <h4>Optional Add-ons</h4>
                    <ul>
                      <li>Seasonal flower refresh (midsummer)</li>
                      <li>Pond or water feature maintenance</li>
                      <li>Outdoor lighting checks</li>
                      <li>Storm debris clean-up</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="season-card-compact fall">
              <div className="season-image">
                <img src="/images/tree/treeHeroImage3.jpg" alt="Fall tree and leaf management" />
              </div>
              <div className="season-content">
                <h3>Fall Services</h3>
                <p className="season-months">September – November</p>
                <div className="services-preview">
                  <ul>
                    <li>Fall cleanup (leaf removal, pruning, garden bed clearing)</li>
                    <li>Irrigation system winterization/blowout</li>
                    <li>Fertilization for winter hardiness</li>
                    <li>Tree/shrub trimming for structure and health</li>
                    <li>Hardscape inspection (pavers, walkways)</li>
                  </ul>
                </div>
                <button className="expand-services-btn" onClick={() => setShowMoreFall(!showMoreFall)}>
                  {showMoreFall ? 'View Less' : 'View More'}
                </button>
                
                <div className={`services-detailed ${showMoreFall ? 'expanded' : ''}`}>
                  <div className="service-category">
                    <h4>Optional Add-ons</h4>
                    <ul>
                      <li>Protective wraps for vulnerable plants</li>
                      <li>Drainage inspection and grading adjustments</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>

            <div className="season-card-compact winter">
              <div className="season-image">
                <img src="/images/projects/sageDemoDriveProject1.jpeg" alt="Winter snow and ice management" />
              </div>
              <div className="season-content">
                <h3>Winter Services</h3>
                <p className="season-months">December – February</p>
                <div className="services-preview">
                  <ul>
                    <li>Snow plowing for driveways and access roads</li>
                    <li>Snow shoveling/Hand clearing</li>
                    <li>Roof snow/ice clearing (if contracted)</li>
                    <li>Ice melt application (eco-safe options available)</li>
                    <li>Emergency storm response</li>
                    <li>Holiday Lighting</li>
                  </ul>
                </div>
                <button className="expand-services-btn" onClick={() => setShowMoreWinter(!showMoreWinter)}>
                  {showMoreWinter ? 'View Less' : 'View More'}
                </button>
                
                <div className={`services-detailed ${showMoreWinter ? 'expanded' : ''}`}>
                  <div className="service-category">
                    <h4>Optional Add-ons</h4>
                    <ul>
                      <li>Post-storm property inspections</li>
                      <li>Heated surface inspection & maintenance</li>
                      <li>Holiday lighting installation/removal</li>
                    </ul>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </div>
      </section>
      
      <section className="section bg-white">
        <div className="section-inner">
          <h2 className="section-title text-center">Featured Services</h2>
        </div>
      </section>
      <ContentSplitSections sections={premiumSections} />
      {/* CTA Section */}
     <CTASection 
  title="READY TO start one or more of our services?"
  subtitle="WHETHER YOU NEED A COMPLETE DESIGN OR ONGOING MAINTENANCE, WE'RE HERE TO HELP"
  galleryLink="/Gallery"
  showEmergency={false}
/>
    </div>
  );
};

export default Premium;
